/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LuBilledAct
 */
export interface LuBilledAct {
    /**
     * 
     * @type {number}
     * @memberof LuBilledAct
     */
    luBilledActId: number;
    /**
     * 
     * @type {string}
     * @memberof LuBilledAct
     */
    actDate: string;
    /**
     * 
     * @type {string}
     * @memberof LuBilledAct
     */
    actDateUntil: string;
    /**
     * 
     * @type {string}
     * @memberof LuBilledAct
     */
    actModificationMultiplier?: string;
    /**
     * 
     * @type {string}
     * @memberof LuBilledAct
     */
    actModificationPrefix?: string;
    /**
     * 
     * @type {string}
     * @memberof LuBilledAct
     */
    actModificationSuffix: string;
    /**
     * 
     * @type {string}
     * @memberof LuBilledAct
     */
    actNumberMultiplier?: string;
    /**
     * 
     * @type {string}
     * @memberof LuBilledAct
     */
    amount: string;
    /**
     * 
     * @type {string}
     * @memberof LuBilledAct
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof LuBilledAct
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof LuBilledAct
     */
    fee: string;
    /**
     * 
     * @type {string}
     * @memberof LuBilledAct
     */
    mainLocation?: string;
    /**
     * 
     * @type {string}
     * @memberof LuBilledAct
     */
    subLocation?: string;
    /**
     * 
     * @type {string}
     * @memberof LuBilledAct
     */
    luHealthProNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof LuBilledAct
     */
    sessionNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof LuBilledAct
     */
    tooth?: string;
    /**
     * 
     * @type {string}
     * @memberof LuBilledAct
     */
    actClass?: string;
    /**
     * 
     * @type {string}
     * @memberof LuBilledAct
     */
    luActType: string;
    /**
     * 
     * @type {boolean}
     * @memberof LuBilledAct
     */
    isSurgeryAct?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LuBilledAct
     */
    isHospiCode?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LuBilledAct
     */
    isFirstHospiDay?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LuBilledAct
     */
    appUserLuActId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LuBilledAct
     */
    isFeeEditable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LuBilledAct
     */
    isCodeExtension?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LuBilledAct
     */
    isPrefixAct?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LuBilledAct
     */
    isSuffixAct?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LuBilledAct
     */
    isMultiplicationAct?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof LuBilledAct
     */
    alerts?: Array<string>;
}

/**
 * Check if a given object implements the LuBilledAct interface.
 */
export function instanceOfLuBilledAct(value: object): value is LuBilledAct {
    if (!('luBilledActId' in value) || value['luBilledActId'] === undefined) return false;
    if (!('actDate' in value) || value['actDate'] === undefined) return false;
    if (!('actDateUntil' in value) || value['actDateUntil'] === undefined) return false;
    if (!('actModificationSuffix' in value) || value['actModificationSuffix'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('fee' in value) || value['fee'] === undefined) return false;
    if (!('luActType' in value) || value['luActType'] === undefined) return false;
    return true;
}

export function LuBilledActFromJSON(json: any): LuBilledAct {
    return LuBilledActFromJSONTyped(json, false);
}

export function LuBilledActFromJSONTyped(json: any, ignoreDiscriminator: boolean): LuBilledAct {
    if (json == null) {
        return json;
    }
    return {
        
        'luBilledActId': json['luBilledActId'],
        'actDate': json['actDate'],
        'actDateUntil': json['actDateUntil'],
        'actModificationMultiplier': json['actModificationMultiplier'] == null ? undefined : json['actModificationMultiplier'],
        'actModificationPrefix': json['actModificationPrefix'] == null ? undefined : json['actModificationPrefix'],
        'actModificationSuffix': json['actModificationSuffix'],
        'actNumberMultiplier': json['actNumberMultiplier'] == null ? undefined : json['actNumberMultiplier'],
        'amount': json['amount'],
        'code': json['code'] == null ? undefined : json['code'],
        'description': json['description'] == null ? undefined : json['description'],
        'fee': json['fee'],
        'mainLocation': json['mainLocation'] == null ? undefined : json['mainLocation'],
        'subLocation': json['subLocation'] == null ? undefined : json['subLocation'],
        'luHealthProNumber': json['luHealthProNumber'] == null ? undefined : json['luHealthProNumber'],
        'sessionNumber': json['sessionNumber'] == null ? undefined : json['sessionNumber'],
        'tooth': json['tooth'] == null ? undefined : json['tooth'],
        'actClass': json['actClass'] == null ? undefined : json['actClass'],
        'luActType': json['luActType'],
        'isSurgeryAct': json['isSurgeryAct'] == null ? undefined : json['isSurgeryAct'],
        'isHospiCode': json['isHospiCode'] == null ? undefined : json['isHospiCode'],
        'isFirstHospiDay': json['isFirstHospiDay'] == null ? undefined : json['isFirstHospiDay'],
        'appUserLuActId': json['appUserLuActId'] == null ? undefined : json['appUserLuActId'],
        'isFeeEditable': json['isFeeEditable'] == null ? undefined : json['isFeeEditable'],
        'isCodeExtension': json['isCodeExtension'] == null ? undefined : json['isCodeExtension'],
        'isPrefixAct': json['isPrefixAct'] == null ? undefined : json['isPrefixAct'],
        'isSuffixAct': json['isSuffixAct'] == null ? undefined : json['isSuffixAct'],
        'isMultiplicationAct': json['isMultiplicationAct'] == null ? undefined : json['isMultiplicationAct'],
        'alerts': json['alerts'] == null ? undefined : json['alerts'],
    };
}

export function LuBilledActToJSON(json: any): LuBilledAct {
    return LuBilledActToJSONTyped(json, false);
}

export function LuBilledActToJSONTyped(value?: LuBilledAct | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'luBilledActId': value['luBilledActId'],
        'actDate': value['actDate'],
        'actDateUntil': value['actDateUntil'],
        'actModificationMultiplier': value['actModificationMultiplier'],
        'actModificationPrefix': value['actModificationPrefix'],
        'actModificationSuffix': value['actModificationSuffix'],
        'actNumberMultiplier': value['actNumberMultiplier'],
        'amount': value['amount'],
        'code': value['code'],
        'description': value['description'],
        'fee': value['fee'],
        'mainLocation': value['mainLocation'],
        'subLocation': value['subLocation'],
        'luHealthProNumber': value['luHealthProNumber'],
        'sessionNumber': value['sessionNumber'],
        'tooth': value['tooth'],
        'actClass': value['actClass'],
        'luActType': value['luActType'],
        'isSurgeryAct': value['isSurgeryAct'],
        'isHospiCode': value['isHospiCode'],
        'isFirstHospiDay': value['isFirstHospiDay'],
        'appUserLuActId': value['appUserLuActId'],
        'isFeeEditable': value['isFeeEditable'],
        'isCodeExtension': value['isCodeExtension'],
        'isPrefixAct': value['isPrefixAct'],
        'isSuffixAct': value['isSuffixAct'],
        'isMultiplicationAct': value['isMultiplicationAct'],
        'alerts': value['alerts'],
    };
}

